import {
  faqs,
  howItWorks,
  purchaseCreditLanguages,
  WinnipegJetsHamburgerTCListItems,
} from "./helpers";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import {
  DefaultRegistrationTerms,
  DefaultCheckoutTerms,
} from "../../default_terms_and_conditions";

import SeatMap3dPreview from "public/images/winnipegjets_flex/SSbackgroundimage.jpg";
import AuthBackgroundBanner from "public/images/winnipegjets_flex/SSbackgroundimage.jpg";
import FindGamesBanner from "public/images/winnipegjets_flex/2526JETS002_01_Membership-Sales_Passport-Website-Graphics_1468x148_V1.jpg";

import type { TeamConfig } from "../types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NHL_2024_v3/jets-assets/Primary%20Logo/NHL_Jets_Primary.png";

const config: TeamConfig = {
  teamSchema: "winnipegjets_passport",
  browserTitle: "Winnipeg Jets Passport",
  packages: false,
  teamName: "Winnipeg Jets",

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.giftCard,
    hideRedeemItem: true,
    hideRecipient: true,
  },

  // disabled routes
  disabledRoutes: [],

  defaultRoute: routes.purchaseCredit,
  phoneNumber: "",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-ca-10006-jets-sec",
    mapId: "main",
  },

  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    showFrontendTotalAmount: true,
    showFrontendServiceFee: true,
    allowManualCartInSimilar: false,
    isPerksEnabled: false,

    defaultSeatCount: 2,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: true,
    showPurchaseCreditLinkInHomeMenu: true,
    isPurchaseCreditHistoryEnabled: true,
    checkoutTimerEnabled: true,
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },
  isSaveCardAllowed: true,

  isBrainTreePaymentEnabled: false,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "G-QGN1EHSF4S",
    attrkPixelId: "",
    beaconId: "",
    metaPixelId: "1900006853612117",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/tnse/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBackgroundBanner.src,
    checkoutStatusPageImage: AuthBackgroundBanner.src,
    giftCardStandalonePageImage: AuthBackgroundBanner.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  colors: {
    primary: "#041E42",
  },

  howItWorks,
  faqs,

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },
    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },

    hideCheckoutCartBalance: true,

    purchaseCredit: {
      purchaseCreditTitle: "WINNIPEG JETS PASSPORT",
      purchaseCreditTitleFont: "avenirNextBold",
      checkoutCreditButtonText: "Purchase Passport",
      checkoutCreditModalTitle: "Add Passport",
      sortCreditPackagesBy: "mostExpensive",
      hideSecondaryTitle: true,
    },

    checkoutPage: {
      zipCodePlaceholder: "Postal Code",
    },
  },

  languages: {
    topNavMenuItems: <WinnipegJetsHamburgerTCListItems />,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: {
      progressBarText: "Add one or more games to continue!",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,
    purchaseCredit: purchaseCreditLanguages,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription:
      "Thank you for your purchase! Tickets will be made available to manage in your Winnipeg Jets Account Manager after August 5th.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
